export interface QuickAction {
  icon: any;
  title: string;
  description: string;
  prompt: string;
}

export const quickActions: QuickAction[] = [
  {
    icon: 'position',
    title: 'Create positioning document',
    description: 'Define your brand positioning clearly',
    prompt:
      'Create a complete brand positioning document for my brand. Include a clear positioning statement, unique value proposition, tone of voice, target audience overview, and three key differentiators that make my brand stand out.',
  },
  {
    icon: 'search',
    title: 'SEO keyword research',
    description: 'Discover relevant keywords for growth',
    prompt:
      'Perform SEO keyword research for my brand. Identify high-intent, low-competition keywords, organize them by theme, and suggest content ideas for blog posts or landing pages around each keyword cluster.',
  },
  {
    icon: 'write',
    title: 'Write blog post',
    description: 'Generate engaging long-form content',
    prompt:
      'Write a detailed blog post for my brand. Include a compelling introduction, practical advice, clear subheadings, SEO-friendly phrasing, and an actionable conclusion with a call to action.',
  },
  {
    icon: 'pencil',
    title: 'Draft newsletter',
    description: 'Email communications and updates',
    prompt:
      'Draft an engaging newsletter for my brand. Include a compelling subject line, friendly introduction, valuable content or updates relevant to my audience, and a clear call to action. Match my brand voice and provide value to subscribers.',
  },
  {
    icon: 'x',
    title: 'Create Twitter post',
    description: 'Concise, engaging tweets',
    prompt:
      'Create an engaging Twitter post for my brand. Write a concise, attention-grabbing tweet with a strong hook, relevant hashtags, and copy that matches my brand voice while staying within Twitter character limits.',
  },
  {
    icon: 'linkedin',
    title: 'Create LinkedIn post',
    description: 'Professional content for LinkedIn',
    prompt:
      'Create an engaging LinkedIn post for my brand. Write professional, thought-leadership content with a strong hook, valuable insights, relevant hashtags, and a caption that matches my brand voice and resonates with a professional audience.',
  },
  {
    icon: 'structure',
    title: 'Create my website structure',
    description: 'Build your content structure',
    prompt:
      'Create a complete website content structure for my brand. Suggest the main pages (Home, About, Features, Pricing, Blog, Contact) and outline the purpose and example copy for each section in a clear, organized format.',
  },
  {
    icon: 'fit',
    title: 'Create a Landing Page',
    description: 'Generate impactful landing pages',
    prompt: `Write a high-converting landing page for my brand. Include a strong headline, subheadline, benefits section, features list, social proof (like testimonials), and a clear call-to-action that fits my brand's tone and audience.`,
  },
  {
    icon: 'share',
    title: 'Write press release',
    description: 'Professional announcements and media outreach',
    prompt:
      'Write a professional press release for my brand announcing a major milestone, product launch, or company news.',
  },
];
